import React from "react";
import { withStyles } from "@material-ui/core";
import { InputBaseComponentProps } from "@material-ui/core/InputBase";
import { Classes, ThemeType } from "@theme";
import CustomerSelectorValue from "./CustomerSelectorValue";
import { Value } from "../base/utils";

export type CustomerSelectorInputProps = InputBaseComponentProps & {
  clearable: boolean;
  classes?: Classes<typeof styles>;
  disabled: boolean;
  onClear: (e: React.SyntheticEvent<any>) => void;
  value?: Value[];
  removeItem: (id: string) => void;
};

class CustomerSelectorInput extends React.Component<CustomerSelectorInputProps> {
  renderEmpty() {
    return (
      <div className={this.props.classes.root} onClick={this.props.onClick as any}>
        &nbsp;
      </div>
    );
  }

  renderValue() {
    return (
      <CustomerSelectorValue
        clearable={this.props.clearable}
        disabled={this.props.disabled}
        onClear={this.props.onClear}
        onClearValue={(id) => {
          this.props.removeItem(id);
        }}
        value={this.props.value}
      />
    );
  }

  render() {
    const hasValue = this.props.value.length > 0;
    return hasValue ? this.renderValue() : this.renderEmpty();
  }
}

const styles = (theme: ThemeType) => ({
  root: {
    padding: "6px 0 5px",
    width: "100%"
  }
});

export default withStyles(styles)(CustomerSelectorInput);
